import {
  useActivePromoCoupon,
  useBestActivePromotionForPlan,
  useCouponComparisonData,
  qualifiesAtVolume,
  doesCouponBeatPromo,
} from '../../../hooks/use-coupon';

export const useIsAcceptingPromotion = (newPlanCode: string, selectedShipmentLimit: number): boolean => {
  const bestActivePromo = useBestActivePromotionForPlan(newPlanCode);
  const activePromoCoupon = useActivePromoCoupon();
  const { couponQualifies, couponDiscountPercent } = useCouponComparisonData(newPlanCode, selectedShipmentLimit);

  if (bestActivePromo) {
    if (!qualifiesAtVolume(bestActivePromo.minEligibleVolume, selectedShipmentLimit)) return false;
    if (couponQualifies && doesCouponBeatPromo(couponDiscountPercent, bestActivePromo.discountPercent)) return false;
    return true;
  }

  if (!activePromoCoupon) return false;

  const isApplicableToPlan =
    activePromoCoupon.applicablePlanCodes.length === 0 ||
    activePromoCoupon.applicablePlanCodes.some((code) => code.toLowerCase() === newPlanCode.toLowerCase());

  if (!isApplicableToPlan) return false;
  if (couponQualifies && doesCouponBeatPromo(couponDiscountPercent, activePromoCoupon.discountPercent)) return false;

  return true;
};
